import {
    useMutation,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'
import requests from 'app/requests/Order/OrderBilling.requests'
import {
    InvoiceDesignation,
} from 'app/enums/label.enums'
import {
    OutgoingInvoice,
} from 'app/Apps/OrderManagement/Orders/orders.types'
import simpleApi from 'app/services/simpleApi'

const useCreateInvoice = ({
    orderNumber,
    onSuccess,
    onError,
}: {
    orderNumber: string,
    onSuccess: (resp: OutgoingInvoice) => void,
    onError: () => void,
}) => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    } = useHandleStatusRequest({
        id: 'CreateInvoice',
        onSuccess,
        onError,
    })

    return useMutation({
        mutationFn: (data: {
            invoiceDesignation: InvoiceDesignation
        }) => {
            return simpleApi({
                ...requests.createOutgoingInvoice({
                    orderNumber,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessRequest,
        onError: onErrorRequest,
    })
}

export default useCreateInvoice
